export default __webpack_public_path__ + "pgnv-assets/1507a3b1b26bd9f56e655dcd76710562.png";